import { render, staticRenderFns } from "./FeebBackSummary.vue?vue&type=template&id=16c25ef2&scoped=true&"
import script from "./FeebBackSummary.vue?vue&type=script&lang=js&"
export * from "./FeebBackSummary.vue?vue&type=script&lang=js&"
import style0 from "./FeebBackSummary.vue?vue&type=style&index=0&id=16c25ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c25ef2",
  null
  
)

export default component.exports